<template>
  <div class="feeling">
    <BasePaneCard
      :isLoading="isLoading"
      heading="Sentimentos"
      unboxed
    >
      <template v-if="dataset.total_messages">
        <div class="feeling__cards">
          <div
            v-for="(value, key) in feelings"
            :key="key"
            class="feeling__cards__feeling"
            :class="`feeling__cards__feeling--${key}`"
          >
            <h4>
              {{ key | feeling | capitalize }}
            </h4>

            <p>
              {{ value | percentage }}
            </p>
          </div>
        </div>
      </template>

      <BaseEmptyState v-else>
        <template v-if="dataset.error">
          <SvgIconRobot/>

          <h3>
            Ops! Algo deu errado...
          </h3>

          <p>
            Por favor tente novamente.
          </p>
        </template>

        <template v-else>
          <h3>
            Este atendimento ainda<br>
            não possui sentimentos.
          </h3>
        </template>
      </BaseEmptyState>
    </BasePaneCard>
  </div>
</template>

<script>
import { percentageFilter, feelingFilter, capitalizeFilter } from '@/utils/filters'
import BasePaneCard from '@/components/base/BasePaneCard'
import BaseEmptyState from '@/components/base/BaseEmptyState'
import { mapState } from 'vuex'
import axios from 'axios'

export default {
  name: 'PartialLeadHistoryFeeling',

  components: {
    BasePaneCard,
    BaseEmptyState
  },

  filters: {
    percentage: percentageFilter,
    feeling: feelingFilter,
    capitalize: capitalizeFilter
  },

  props: {
    leadId: Number
  },

  data () {
    return {
      isLoading: false,
      dataset: {}
    }
  },

  computed: {
    ...mapState('base', ['mainApi']),

    feelings () {
      const totalMessages = this.dataset.total_messages | 0

      let feeling = {
        negative: 0,
        neutral: 0,
        positive: 0
      }

      if (totalMessages) {
        const {
          negative_sentiment: negative,
          neutral_sentiment: neutral,
          positive_sentiment: positive

        } = this.dataset

        feeling = {
          negative: (negative * 100) / totalMessages,
          neutral: (neutral * 100) / totalMessages,
          positive: (positive * 100) / totalMessages
        }
      }

      return feeling
    }
  },

  watch: {
    leadId () {
      this.fetchData()
    }
  },

  mounted () {
    this.fetchData()
  },

  methods: {
    async fetchData () {
      if (!this.leadId) {
        return
      }

      this.isLoading = true

      try {
        const url = `${this.mainApi}integration/app/get-sentiment/${this.leadId}`
        const response = await axios.get(url)

        this.dataset = response.data
      } catch (error) {
        this.dataset = { error }

        throw error
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.feeling {
  /deep/ {
    .pane-card {
      &__body {
        height: 90px;
        overflow: hidden;
      }
    }

    .heading {
      &--small {
        font: {
          weight: 600;
          size: 14px;
        }
      }
    }
  }

  &__cards {
    display: flex;
    height: 100%;
    gap: 30px;
    justify-content: center;
    align-items: center;

    &__feeling {
      display: flex;
      flex-direction: column;
      align-items: center;

      &::before {
        $size: 30px;

        content: '';
        display: block;
        width: $size;
        height: $size;
        border-radius: 100%;
        background: {
          color: rgba(nth($colors-custom, 2), 0.5);
          position: 50% 50%;
          repeat: no-repeat;
          size: 60% auto;
        }
      }

      &--negative {
        &::before {
          background-image: url('~@/assets/img/main/icons/icon-face-sad-component.svg');
        }
      }

      &--neutral {
        &::before {
          background-image: url('~@/assets/img/main/icons/icon-face-neutral-component.svg');
        }
      }

      &--positive {
        &::before {
          background-image: url('~@/assets/img/main/icons/icon-face-happy-component.svg');
        }
      }

      h4 {
        margin-top: 10px;
        font: {
          weight: 400;
          size: 12px;
        }
        line-height: 100%;
      }

      p {
        margin-top: 5px;
        font: {
          weight: 700;
          size: 12px;
        }
        line-height: 100%;
      }
    }
  }
}
</style>
